import styled from 'styled-components';

export const StepsContainer = styled.div`
	border-radius: 1rem;
	padding: 2.5rem !important;
	background-color: #ffffff;
`;

export const Icon = styled.div`
	display: inline-block;
`;

export const RowHeader = styled.div`
	font-size: 18px !important;
	font-weight: 600 !important;
`;
